<style lang="scss" scoped>
  @import '../../../sass/variables';

  .pointer {
    transition: 300ms;
    position: relative;
    text-align: center;
    margin-bottom: 20px;

    &:hover {
      &.thumb {
        transform: translateY(-5px);

        > div {
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }

  .thumb {
    padding: 15px 15px;
    margin: 0px 0px;
    border-radius: 5px;
    display: inline;

    &:hover {
      .delete-model {
        display: block;
      }

      .theme-blur,
      .theme-select {
        visibility: visible;
      }
    }

    .delete-model {
      display: none;
      border-radius: 15px 15px 0 0;
      background-color: #eae6f0;
      font-size: 13px;
      font-weight: 400;
      color: #3b334a;
      letter-spacing: -0.18px;
      height: 50px;
      margin: -24px;
      padding: 15px;
      z-index: 10;
      position: relative;

      i {
        font-size: 20px;
      }
    }

    > div {
      transition: 300ms;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0);
    }

    img {
      margin: 0;
      max-width: 100%;
      transition: 300ms;
      border-radius: 5px;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0);
    }

    h5 {
      max-width: 120px;
      font-weight: 300;
      margin: 10px auto 0;
    }
  }

  .loading {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    position: absolute;
    background-color: rgba(217, 224, 231, 0.4);

    i {
      color: #fff;
      font-size: 30px;
      margin-top: 50%;
    }
  }

  .placeholder {
    color: #fff;
    padding: 15px;
    display: flex;
    border-radius: 4px;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    i,
    span {
      margin-top: 25px;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: -0.21px;
      line-height: 25px;
      color: #3b334a;
    }

    .fa {
      font-size: 28px;
    }

    .fa-trash {
      top: 15px;
      right: 15px;
      padding: 5px 6px;
      border-radius: 2px;
      position: absolute;
      font-size: 14px !important;

      &:hover {
        background-color: rgba(30, 30, 30, .2);
      }
    }
  }

  .reorderingLoading {
    top: 0;
    left: 25px;
    opacity: 0;
    color: #00acac;
    font-size: 30px;
    position: absolute;
  }

  .hide {
    opacity: 0 !important;
  }

  .show {
    opacity: 1 !important;
  }

  .html-placeholder {
    height: 213px;
    position: relative;
    border-radius: 15px;
    background-color: #ffffff;
    box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);
  }

  .page-header.title {
    color: #f4f2f7;
    font-size: 26px;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: -0.39px;
  }

  .bg-light-gray {
    background-color: #f4f2f8;
    box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);

    .content {
      padding: 10px 30px;
    }
  }

  .rounded-20-no-right {
    border-radius: 20px 0 0 20px;
  }

  .rounded-15 {
    position: relative;
    border-radius: 15px;
  }

  .w-275 {
    width: 275px;
  }

  .h-213 {
    height: 213px;
  }

  .filter-title {
    font-weight: 400;
    line-height: 30px;
    letter-spacing: -0.27px;
    color: #3b334a;
  }

  .bd-breadcrumb__item label {
    color: #f4f2f7;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: -0.15px;
    line-height: 30px;
    text-transform: uppercase;
    cursor: pointer;

    margin: 0;
  }

  .categories {
    width: 280px;
    flex: 0 0 280px;
    padding-bottom: 30px;

    &__menu {
      top: 162px;
      position: absolute;
    }
  }

  .theme-blur {
    background: $white;
    opacity: 0.7;
  }

  .theme-blur,
  .theme-select {
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    display: flex;
    position: absolute;
    align-items: center;
    border-radius: 15px;
    visibility: hidden;

    &:hover {
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    }
  }

  .confirm-title {
    color: #3b334a;
    font-size: 20px;
    margin-bottom: 15px;
    font-weight: 400;
  }
</style>

<template>
  <div>
    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <h2
          class="page-subtitle"
          v-if="isUpdating"
        >
          {{ __('Alterar Template') }}
        </h2>
        <h2
          class="page-subtitle"
          v-else
        >
          {{ __('Escolha um template para iniciar') }}
        </h2>
      </div>
    </div>
    <div class="row ml-0 mr-0 bg-light-gray rounded-20-no-right mt-4 mb-5">
      <div class="col-10 content">
        <Masonry
          :cols="{ default: 4, 1366: 3, 1024: 2 }"
          gutter="25"
        >
          <div
            class="pointer thumb"
            @click="changeTemplate()"
          >
            <div class="placeholder html-placeholder pt-4">
              <div class="theme-blur" />
              <div class="theme-select">
                <span class="btn btn-primary f-w-500 mx-auto">Selecionar</span>
              </div><img
                src="/build/icons/edit-html@2x.png"
                height="80px"
              ><span>{{ __('Editor HTML') }}</span>
            </div>
          </div>

          <div
            class="pointer thumb"
            :key="index"
            @click.prevent="changeTemplate(template.id)"
            v-for="(template, index) in templatesFiltered"
          >
            <div
              class="bg-white p-4 rounded-15"
              :class="{'h-213': category === 'default' && index === 0}"
            >
              <div class="theme-blur" />
              <div class="theme-select">
                <span class="btn btn-primary f-w-500 mx-auto">Selecionar</span>
              </div>
              <div
                class="delete-model"
                v-b-tooltip="__('Excluir modelo')"
                @click.prevent.stop="destroy(template.id)"
                v-if="! template.category"
              >
                <span>{{ __('Excluir modelo') }}</span><i class="fa fa-trash-o ml-3" />
              </div><img
                :src="template.thumbnail"
                v-if="template.thumbnail"
              >
              <div
                class="placeholder"
                :style="{ height: getHeight(template.title) }"
                v-else
              >
                <div
                  class="icon"
                  v-if="template.category"
                >
                  <img
                    src="/build/icons/file@2x.png"
                    height="80px"
                  >
                </div>
                <div
                  class="icon"
                  v-else
                >
                  <i class="fa fa-star" />
                </div><span v-if="template.title == 'Blank'">{{ __('Em branco') }}</span><span
                  v-text="__(template.title)"
                  v-else
                />
              </div>
              <h5
                v-text="__(template.title)"
                v-if="template.thumbnail"
              />
              <div
                class="loading"
                v-if="loading == template.id"
              >
                <i class="fa fa-circle-o-notch fa-spin" />
              </div>
            </div>
          </div>
        </Masonry>
        <div :class="['reorderingLoading', reordering ? 'show' : '']">
          <i class="fa fa-circle-o-notch fa-spin" />
        </div>
      </div>
    </div>
    <div class="categories ml-auto">
      <CategoryMenu
        class="categories__menu"
        scrollfix="scrollfix"
        :categories="categories"
        @update="(category) => this.category = category"
      />
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import Swal from 'sweetalert2';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: ['templates', 'route', 'is-updating', 'categories'],

  data () {
    return {
      category: 'default',
      reordering: true,
      loading: -1,
      // categories: {
      //   default: {
      //     title: this.__('Todos os temas'),
      //   },
      //   simple: {
      //     title: this.__('Simples'),
      //   },
      //   newsletter: {
      //     title: 'Black Newsletter',
      //   },
      //   ecommerce: {
      //     title: 'Ecommerce',
      //   },
      //   promo: {
      //     title: this.__('Promocional'),
      //   },
      //   custom: {
      //     title: this.__('Meus templates'),
      //   },
      // },
    };
  },

  mounted () {
    this.templates.unshift(
      ...this.templates.filter((t) => t.category == 'none')
        .map((t) => this.templates.splice(this.templates.indexOf(t), 1))
        .pop(), // I know
    );

    setTimeout(() => this.reordering = false, 300);

    Bus.$on('AsideActive', (category) => {
      if (this.category != category) {
        this.category = category;
      }
    });
  },

  watch: {
    category () {
      this.$nextTick(() => {
        this.reorder();
      });
    },
  },

  computed: {
    templatesFiltered () {
      if (this.category === 'default') {
        return this.templates;
      }

      if (this.category === 'custom') {
        const customs = this.templates.filter((template) => ! template.category);

        if (customs.length) {
          return customs;
        }

        this.category = 'default';

        Bus.$emit('AsideMenuActive', 'default');

        return this.templates;
      }

      return this.templates.filter((template) => {
        if (this.category === 'all') {
          return true;
        }

        return template.category?.includes(this.category);
      });
    },
  },

  methods: {
    getHeight (title) {
      return `${189}px`;
      const sum = title.toUpperCase().split('').reduce((total, letter) => total + letter.charCodeAt(0) - 64, 0);

      return `${150 + (sum >= 200 ? 200 : sum)}px`;
    },

    getColor (title) {
      return window.colorFromString(title);
    },

    reorder () {
      this.reordering = true;

      setTimeout(() => {
        this.reordering = false;
      }, 500);
    },

    toggleLoading (template_id) {
      if (this.loading == template_id) {
        this.loading = -1;
      } else {
        this.loading = template_id;
      }
    },

    changeTemplate (template_id) {
      this.toggleLoading(template_id);

      if (! this.isUpdating) {
        return this.save(template_id);
      }

      Swal.fire({
        icon: 'question',
        title: this.__('Deseja confirmar alteração do template?'),
        html: `<span style="color: #3b334a;font-size: 14px;line-height: 25px;font-weight: 400;">${this.__('Ao confirmar você perderá todo o conteúdo atual.')}</span>`,
        width: 370,
        buttonsStyling: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonColor: 'transparent',
        confirmButtonText: this.__('Confirmar'),
        cancelButtonText: this.__('Cancelar'),
        showCancelButton: true,
        customClass: {
          title: 'confirm-title',
          container: 'container-swal2',
          confirmButton: 'btn btn-primary ',
          cancelButton: 'btn mt-2 text-decoration-underline font-weight-normal',
        },
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          this.save(template_id);
        } else {
          this.toggleLoading(template_id);
        }
      });
    },

    save (template_id) {
      if (template_id) {
        this.editAsBee(template_id);
      } else {
        this.editAsHTML();
      }
    },

    editAsBee (template_id) {
      this.$http.put(this.route, { template: template_id })
        .then(({ data: mail }) => {
          window.localStorage.setItem(`mail.autosave.${mail.id}`, '{}');
          window.location = `/mail/${mail.id}/builder`;
        });
    },

    editAsHTML () {
      this.$http.put(this.route, { edit_html: true }).then(({ data: mail }) => {
        window.location = `/mail/${mail.id}`;
      });
    },

    destroy (id) {
      Swal.fire({
        icon: 'question',
        title: this.__('Excluir template?'),
        width: 350,
        buttonsStyling: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonColor: 'transparent',
        confirmButtonText: this.__('Confirmar'),
        cancelButtonClass: 'btn mt-2 text-decoration-underline font-weight-normal',
        cancelButtonText: this.__('Cancelar'),
        showCancelButton: true,
        customClass: {
          title: 'confirm-title',
          container: 'container-swal2',
          confirmButton: 'btn btn-primary ',
          cancelButton: 'btn mt-2 text-decoration-underline font-weight-normal',
        },
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          this.$http.delete(`/mail/template/${id}`).then(() => {
            const index = this.templates.indexOf(this.templates.find((template) => template.id == id));
            this.templates.splice(index, 1);
          });
        }
      });
    },
  },
};
</script>
